module.exports = __webpack_public_path__ + "assets_1750490680271/img/pic_5.cab60e24.png";